import { LdapUser } from "../../interfaces/ldap-user/ldap-user.interface";
import { PagingResponse } from '../../interfaces/paging/paging-response.interface';

export class PagingResponseUsersModel implements PagingResponse<LdapUser> {
  content: Array<LdapUser>;
  pageable: {
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;

  constructor(
    content?: Array<LdapUser>,
    pageable?: {
      sort: {
        unsorted: boolean;
        sorted: boolean;
        empty: boolean;
      };
      offset: number;
      pageSize: number;
      pageNumber: number;
      paged: boolean;
      unpaged: boolean;
    },
    totalPages?: number,
    totalElements?: number,
    last = false,
    first = false,
    sort?: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    },
    numberOfElements?: number,
    size?: number,
    number?: number,
    empty = false
  ) {
    this.content = content ? content : [];
    this.pageable = pageable ? pageable : null;
    this.totalPages = totalPages ? totalPages : 0;
    this.totalElements = totalElements ? totalElements : 0;
    this.last = last ? last : null;
    this.first = first ? first : null;
    this.sort = sort ? sort : null;
    this.numberOfElements = numberOfElements ? numberOfElements : null;
    this.size = size ? size : null;
    this.number = number ? number : null;
    this.empty = empty ? empty : null;
  }
}
